import { render } from "./PremiumBadge.vue?vue&type=template&id=2ac76fb6&scoped=true"
import script from "./PremiumBadge.vue?vue&type=script&lang=js"
export * from "./PremiumBadge.vue?vue&type=script&lang=js"

import "./PremiumBadge.vue?vue&type=style&index=0&id=2ac76fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac76fb6"]])

export default __exports__